import { globalLogger } from '../../qaamgo/helper/global-logger';
import { testIsObject, testIsString, testObjectHasKey } from '../../lib/test-and-assert/test-base';

/**
 * Our APIs always respond with JSON objects. This means that the server response we get
 * from the Ajax Wrapper should always be an object.
 *
 * Unfortuantley some really old browser can't parse the JSON-string into an object. in
 * such cases we get a string instead of an object.
 *
 * Therefore we try to fix it with the following approach:
 *
 * 1) if the serverResponse is not a string then we just return it
 * 2) if it is a string and a valid JSON object we return that new object
 * 3) if it is a string but not a valid JSON object then we return the original response
 *
 * @param serverResponse
 *
 * @return {*}
 */
function fixOldBrowser(serverResponse) {
    if (!testIsString(serverResponse)) {
        return serverResponse;
    }

    try {
        var newResponse = JSON.parse(serverResponse);

        if (testIsObject(newResponse)) {
            globalLogger.log('qgApiHelper server response was fixed', JSON.stringify(serverResponse));

            return newResponse;
        }
    } catch (e) {
        // do nothing
    }

    globalLogger.log('qgApiHelper server response was not fixed', JSON.stringify(serverResponse));

    return serverResponse;
}

/**
 * This is a 'feature' unique to the frontend, it does not happen in other projects
 *
 * @param serverResponse
 *
 * @return {?OcError}
 */
function getOcErrorFromServerResponse(serverResponse) {
    if (!testIsObject(serverResponse)) {
        return null;
    }

    if (!testObjectHasKey(serverResponse, 'code')) {
        return null;
    }

    // warning: sats and DL use 'message' instead of 'text'
    if (!testObjectHasKey(serverResponse, 'text')) {
        return null;
    }

    return {
        code: serverResponse.code,
        text: serverResponse.text,
    };
}

/**
 * If a request fails and we end up in fail(), then we check if jqXHR contains
 * an SatError object
 *
 * @param {JQueryXHR} jqXHR
 *
 * @return {?SatError}
 */
function getSatErrorFromJqXHR(jqXHR) {
    if (!testIsObject(jqXHR)) {
        return null;
    }

    if (!testIsObject(jqXHR.responseJSON)) {
        return null;
    }

    var json = jqXHR.responseJSON;

    if (!testObjectHasKey(json, 'code')) {
        return null;
    }

    // warning: oc uses 'text' instead of 'message'
    if (!testObjectHasKey(json, 'message')) {
        return null;
    }

    return {
        code: json.code,
        message: json.message,
    };
}

export { fixOldBrowser };
export { getOcErrorFromServerResponse };
export { getSatErrorFromJqXHR };
